import Mustache from 'mustache';
import Toggle from './toggle';

class TyreSizes {

  /**
   * Add functionality to Custom element Tyre sizes
   *
   * @param {HTMLElement} el Element to wrap.
   */
  constructor(el) {
    this.element = el;

    const itemTemplate = document.getElementById('tyreItemTemplate');
    const buttons = el.querySelectorAll('.js-tyre-sizes-button');
    const toggle = el.querySelector('.js-toggle');
    const container = el.querySelector('.js-tyre-sizes-container');
    const content = el.querySelector('.js-tyre-sizes-content');

    buttons.forEach(b => {
      if (!b.classList.contains('js-toggle')) {
        b.addEventListener('click', (e) => {
          // Open tyres container if not open
          if (container.classList.contains('hidden')) {
            toggle.classList.add('is-toggled')
            toggle.setAttribute('open', true);
            container.classList.remove('hidden')
          }

          buttons.forEach(btn => {
            if (btn.classList.contains('active')){
              btn.classList.remove('active');
            }
          })

          b.classList.add('active');

          // Render new items
          content.innerHTML = Mustache.render(itemTemplate.innerHTML, { items: JSON.parse(b.dataset.tyres) });

          //Toggles
          const toggles = content.querySelectorAll('.js-toggle');
          toggles.forEach(el => {
            new Toggle(el);
          });
        })
      }
    })
  }
}

export default TyreSizes;
